import { Search } from 'lucide-react';
import {
  CATEGORY_CONFIG,
  SEVERITY_CONFIG,
  TIMING_CONFIG,
} from '../../constants/editCheckOptions';

interface EditCheckFiltersProps {
  search: string;
  onSearchChange: (value: string) => void;
  category: string;
  onCategoryChange: (value: string) => void;
  severity: string;
  onSeverityChange: (value: string) => void;
  timing: string;
  onTimingChange: (value: string) => void;
  activeFilter: string;
  onActiveFilterChange: (value: string) => void;
  source: string;
  onSourceChange: (value: string) => void;
  totalCount: number;
  filteredCount: number;
}

const selectClass =
  'px-3 py-1.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary-500/40';

export default function EditCheckFilters({
  search,
  onSearchChange,
  category,
  onCategoryChange,
  severity,
  onSeverityChange,
  timing,
  onTimingChange,
  activeFilter,
  onActiveFilterChange,
  source,
  onSourceChange,
  totalCount,
  filteredCount,
}: EditCheckFiltersProps) {
  return (
    <div className="flex flex-wrap items-center gap-3">
      {/* Search */}
      <div className="relative flex-1 min-w-[200px]">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
        <input
          type="text"
          placeholder="Search checks..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          className={`${selectClass} pl-9 w-full`}
        />
      </div>

      {/* Category */}
      <select
        value={category}
        onChange={(e) => onCategoryChange(e.target.value)}
        className={selectClass}
      >
        <option value="">All Categories</option>
        {Object.entries(CATEGORY_CONFIG).map(([key, cfg]) => (
          <option key={key} value={key}>
            {cfg.label}
          </option>
        ))}
      </select>

      {/* Severity */}
      <select
        value={severity}
        onChange={(e) => onSeverityChange(e.target.value)}
        className={selectClass}
      >
        <option value="">All Severities</option>
        {Object.entries(SEVERITY_CONFIG).map(([key, cfg]) => (
          <option key={key} value={key}>
            {cfg.label}
          </option>
        ))}
      </select>

      {/* Timing */}
      <select
        value={timing}
        onChange={(e) => onTimingChange(e.target.value)}
        className={selectClass}
      >
        <option value="">All Timing</option>
        {Object.entries(TIMING_CONFIG).map(([key, cfg]) => (
          <option key={key} value={key}>
            {cfg.label}
          </option>
        ))}
      </select>

      {/* Where the check came from (D7) */}
      <select
        value={source}
        onChange={(e) => onSourceChange(e.target.value)}
        className={selectClass}
      >
        <option value="">All sources</option>
        <option value="dictionary">From your data dictionary</option>
        <option value="family">Written by rule</option>
        <option value="default_range">Default ranges (sponsor to confirm)</option>
        <option value="generated">Generated</option>
      </select>

      {/* Active filter */}
      <select
        value={activeFilter}
        onChange={(e) => onActiveFilterChange(e.target.value)}
        className={selectClass}
      >
        <option value="">All</option>
        <option value="active">Active</option>
        <option value="inactive">Inactive</option>
      </select>

      {/* Count */}
      <span className="text-xs text-gray-500 whitespace-nowrap">
        {filteredCount === totalCount
          ? `${totalCount} checks`
          : `${filteredCount} of ${totalCount} checks`}
      </span>
    </div>
  );
}
